module.exports = __webpack_public_path__ + "static/media/introduction_for_maintenance.195e38cd.png";